import React from 'react';
import Draggable from 'react-draggable';
import { ThemeProvider } from 'styled-components';
import TriggerButton from '../components/buttons/trigger';
import Divider from '../components/divider';
import Footer from '../components/footer';
import Header from '../components/header';
import Popup, { POPUP_TYPE } from '../components/popup';
import Settings, { defaultSettings, setLinearGradient } from '../context/settings';
import theme from '../context/theme';
import I18n from '../utils/i18n';
import isMobile from '../utils/mobilecheck';
import Pages from './pages';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import ga from '../utils/ga-tracker';
import { closePluginButton, openPluginButton } from '../utils/alt-tags';


const PLUGIN_MODE = (process.env.REACT_APP_BUILD_MODE === 'plugin');

const pluginHeight = 450;
const pluginWidth = 420;
const hostedHeight = 550;
const hostedWidth = 458;
const hostedWidthPercent = 0.35;
const publicHostedWidthPercent = 0.5;
const pluginWidthPercent = 0.30;
const heightPercent = 0.80;

const VOX_POSITION_ENUM = {
	defaultPosition: 'flex-end',
	center: 'center'
};


const VOX_BUTTON_SHAPE = {
	default: 'default',
	rectangle: 'rectangle'
};

const PluginContainer = styled.div`
	${() => {
	let styles = ``;
	const addStyle = (addition) => { styles = `${styles} ${addition}` };
	switch (process.env.REACT_APP_BUILD_MODE) {
		case 'sample': addStyle`
				width: 100%;
				height: 100%;

				max-width: 100vw;
				max-height: unset;

				min-height: 100vh;
			`;
			break;
		case 'plugin': addStyle`
				width: 100%;
				height: 100%;
			`;
			break;
		case 'hosted': addStyle`
				align-self: center;
				padding-bottom: 12px;
				@media (max-width: 599px) {
					align-self: baseline;
				}
			`;
			break;
		default: addStyle`			
				${breakpoint('xs', 'sm')`
					padding: 0 0.5rem;
				`}
			`;
	}

	return css`${styles}`;
}};

	position: relative;
	pointer-events: none;

	text-align: center;

	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-end;

	.plugin-content {
		pointer-events: all;

		height: 100%;
		width: 100%;

		display: flex;
		flex-direction: column;

		border-radius: 0.4rem;
		border-style: none;
		border-width: 0.1rem;
		border-color: #ddd;

		transition: opacity 0.5s ease-in-out;
		&.active {
			opacity: 1;
		}

		&.inactive {
			opacity: 0;
			visibility: hidden;
		}
	}

	.hide {
		visibility: hidden;
	}

	.no-pointer {
		cursor: default;
	}
`;

const VoxTrigger = styled(TriggerButton)`
	pointer-events: all;
`;

const VoxPosition = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: ${props => (props.voxButtonShape === VOX_BUTTON_SHAPE.rectangle ? 'flex-start' : (props.center ? 'center' : VOX_POSITION_ENUM[props.voxPosition] || 'center'))};
	align-items: ${props => (props.voxButtonShape === VOX_BUTTON_SHAPE.rectangle || props.center) ? 'center' : VOX_POSITION_ENUM[props.voxPosition] || 'center'};
`;

const SubContainer = styled.div`
  border: ${props => props.settings.common.requiredShadow && '0.04rem solid #ddd' }
  box-shadow: ${props => props.settings.common.requiredShadow && '0px 0px 20px rgba(0, 0, 0, 0.1)'};
  ${props => props.settings.common.voxButtonShape === 'rectangle' && props.mode === "plugin" && css`
		transform-origin: top;
		margin-top: 0.5rem;
	`}
	${props => props.defaultPosition && !props.isFrame && props.mode === "plugin"
	&& css`transform-origin: bottom right;
			margin-bottom: 1rem;
  			margin-right: 1rem;
  			`}
	${props => !props.isFrame || props.ownTriggerButton ? `
		@media (max-width: 599px) {
			-webkit-transform: scale(${props.vWidth / (props.mode === "plugin" ? 
	(props.width + 72) : props.width)});
			-moz-transform: scale(${props.vWidth / props.width});
			${props.mode === "hosted" && "-webkit-transform-origin-y: top;"}
		}
		@media (min-width: 600px) { 
			-webkit-transform: scale(${
			(((props.vWidth * props.widthPercent) * props.aspectRatio) > (props.vHeight * props.heightPercent)) ?
				((props.vHeight * props.heightPercent) / props.height) :
			(((props.vWidth * props.widthPercent) * props.aspectRatio) < (props.vHeight * 0.5)) ?
			((props.vHeight * 0.5) / props.height) : ((props.vWidth * 
				props.widthPercent) / props.width)
		});
			-moz-transform: scale(${
	(((props.vWidth * props.widthPercent) * props.aspectRatio) > (props.vHeight * props.heightPercent)) ?
		((props.vHeight * props.heightPercent) / props.height) :
		(((props.vWidth * props.widthPercent) * props.aspectRatio) < (props.vHeight * 0.5)) ?
			((props.vHeight * 0.5) / props.height) : ((props.vWidth *
			props.widthPercent) / props.width)
});
	}
	` : `
		-webkit-transform: scale(${props.vWidth / (props.width + 32)});
		-moz-transform: scale(${props.vWidth / (props.width + 32)});
	`}
	${() => {
	let styles = ``;
	const addStyle = (addition) => { styles = `${styles} ${addition}` };
	switch (process.env.REACT_APP_BUILD_MODE) {

		case 'plugin': addStyle`
  				height: 450px;
				width: 420px;
			`;
			break;
		case 'hosted': addStyle`
				height: 550px;
				width: 458px;
			`;
			break;
	}

	return css`${styles}`;
}};

  background: #FFFFFF;
  box-sizing: border-box;
  border-radius: 7px !important;
  ${props => props.mode === "hosted"
	&& css`  
	@media (max-width: 599px) {
  		border-radius: 0 !important;
  	}
  `}
  ${({ mode }) => mode === 'plugin' && `
  border : 1px solid #F1F1F1 !important;
  z-index: 9;
  `}
`;

export default class Plugin extends React.Component {
	state = {
		settings: null,
		popup: null,
		page: 'start',
		pageProps: {
			pluginMode: PLUGIN_MODE
		},
		localVersion: 0,
		active: false,
        isFrame: false,
		ownTriggerButton: false,
		// If we're in hosted mode, immediately check for mic-access
		checkMic: (process.env.REACT_APP_BUILD_MODE === 'hosted'),
		micAllowed: false,
		audioContext: null,
		viewportWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
		viewportHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
	};

	constructor(props) {
		super(props);

		this.togglePlugin = this.togglePlugin.bind(this);
		this.externalToggle = this.externalToggle.bind(this);
		this.handleAudioContext = this.handleAudioContext.bind(this);
		this.updateSize = this.updateSize.bind(this);
	}

	/**
	 * Updates the settings object with computed
	 * properties derived from persisted settings
	 */
	async updateSettings(settings) {
		// update the linear gradient
		setLinearGradient(settings);

		// Update the localisation service
		await I18n.init(settings);
	}

	handleClickOutside = (e) => {
		var path = e.path || (e.composedPath && e.composedPath());
		const found = path.find(element => element.classList && element.classList.contains("trigger-button"));
		if (this.wrapperRef && !this.wrapperRef.contains(e.target) &&
			this.state.active && this.state.settings.mode === 'plugin') {
			if (this.state.isFrame) {
        		window.parent.postMessage("outside", "*");
        	} else if (!found) {
				this.togglePlugin()
			}
			window.postMessage("ClosePluginEvent", "*")
        }
    };

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };


    parseQuery = (queryString) => {
        const query = {};
        const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    };

	async componentDidMount() {
        const { isFrame, ownTriggerButton } = this.parseQuery(window.location.search);
        if (isFrame) {
			if (ownTriggerButton) {
				this.setState({ active: true, isFrame: true, ownTriggerButton: true, })
			} else {
				this.setState({ active: true, isFrame: true })
			}
        }
        const { page: pageOverride } = this.props;
		// Fetch the settings on load
		const settings = defaultSettings; // await fetchSettings();

		// Update the computed settings
		await this.updateSettings(settings);

		// Any dynamic scripts to be loaded can be added here
		if (PLUGIN_MODE){
			window.parent.postMessage("createBackground", "*");
		}

		// Update the state, to render the plugin
		this.setState({
			settings,
			page: pageOverride || this.state.page,
			popup: isMobile.CriOS() ? POPUP_TYPE.crios : null
		});

		this.attachListeners(true);

		// Setup tracking, internally checks flag
		ga.initialize();
	}

	componentWillUnmount() {
		this.attachListeners(false);
	}
	updateSize() {
		this.setState({
			viewportWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
			viewportHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
		});
	}
	async componentDidUpdate({ settings: oldLocal }, { localVersion: oldVersion }) {
		// If the local settings changed
		const { settings: newLocal } = this.props;

		if (oldLocal !== newLocal) {
			// Update the computed settings
			await this.updateSettings(newLocal);

			//  Trigger a text refresh
			this.setState({ localVersion: oldVersion + 1 });
		}

		if (this.state.checkMic) {
			// Lazy check permission
			// await this.checkMicPermission();
		}
	}

	attachListeners(attach) {
		const { pages } = this.state.settings || {};
		const { triggerIds } = pages || {};

		if (attach) {
            window.addEventListener('mouseup', this.handleClickOutside);
            window.addEventListener('message', this.externalToggle);
			window.addEventListener('resize', this.updateSize);
		} else {
			window.removeEventListener('message', this.externalToggle);
            window.removeEventListener('mouseup', this.handleClickOutside);
			window.removeEventListener('resize', this.updateSize);
        }

		if (triggerIds && triggerIds.length > 0) {
			triggerIds.map(id => {
				const trigger = document.getElementById(id);

				if (trigger) {
					if (attach) {
						trigger.addEventListener('click', this.togglePlugin);
						trigger.addEventListener('touchstart', this.togglePlugin);
					} else {
						trigger.removeEventListener('click', this.togglePlugin);
						trigger.removeEventListener('touchstart', this.togglePlugin);
					}
				}
				return null;
			})
		}
	}

	/**
	 * Checks if the plugin has access to the mic
	 * @deprecated
	 */
	async checkMicPermission() {
		// let targetPage = this.state.page;
		let micAllowed = false;

		try {
			// Check the user permission
			await navigator.mediaDevices.getUserMedia({ audio: true });
			micAllowed = true;
		} catch (err) {

		}

		// Update the state, to render the plugin
		this.setState({
			checkMic: false,
			micAllowed
		});
	}

	externalToggle(event) {
		if (event.source !== window)
			this.togglePlugin();
	}

	async togglePlugin(event) {
		const { active, micAllowed, page } = this.state;
		const toggled = !active ? !active : (!event ? !active : active);
		const settings = defaultSettings; // await fetchSettings();

		if (event) event.preventDefault();

		if (ga.initialized)
			ga.f.event({
				category: 'interaction',
				action: 'toggle'
			})

		// Simple toggle
		this.setState({
			page: (page === 'complete' && !toggled) ? 'start' : page,
			active: toggled,
			// If we're in plugin mode, check for mic access on toggle only
			// This is to ensure the user knows why the permission is requested
			checkMic: toggled && !micAllowed && (process.env.REACT_APP_BUILD_MODE === 'plugin')
		});

		if (window.parent) {
			let msg = {toggled: toggled ? 'active': 'inactive', dimBackground: settings.common.dimBackground ? true : false}
			window.parent.postMessage(msg, '*');
		}
	}

	switchPage(newPage, newProps = {}) {
		const { onChange } = this.props;
		const { micAllowed, pageProps: oldProps } = this.state;

		if (ga.initialized)
			ga.f.event({
				category: 'interaction',
				action: 'switch-page',
				label: this.state.page,
				value: 1
			})

		// Update the active page
		this.setState({
			page: newPage,
			pageProps: {
				...oldProps,
				...newProps
			},
			micAllowed
		});

		// Inform any listeners about the change
		if (onChange) onChange(newPage);
	}

	handleAudioContext(audioCon) {
		this.setState({
		  audioContext: audioCon
		});
	};

	render() {
		const { settings, popup, page, pageProps, active, micAllowed,
			isFrame, audioContext, viewportWidth, viewportHeight, ownTriggerButton } = this.state;
		const { settings: localSettings, page: pageOverride } = this.props;
		// If an override is set, stay active
		const isActive = active || !!pageOverride;

		// Are we in a build where the view is fixed?
		const inFixedMode = settings && settings.fixedModes.indexOf(process.env.REACT_APP_BUILD_MODE) >= 0;

		return settings ? (
			<Draggable axis="x" handle=".trigger-button" allowAnyClick={false}>
				<ThemeProvider theme={theme}>
					<PluginContainer className={`plugin ${(isActive || inFixedMode) ? 'active' : 'inactive'}`}
						isPublicHosted={settings && settings.common.isPublicHosted ? 'public' : ''}
					>
						{/* Provide settings globally, as a context */}
						<Settings.Provider value={localSettings || settings}>
							<VoxPosition
								voxPosition={settings.common.voxPosition}
								voxButtonShape={settings.common.voxButtonShape}
								center={isFrame}
								className={`plugin-content ${(isActive || inFixedMode) ? 'active' : 'inactive'}`}
							>
								<SubContainer
                                    ref={this.setWrapperRef}
									settings={settings}
									mode = {settings.mode}
									vWidth={viewportWidth}
									vHeight={viewportHeight}
									width={PLUGIN_MODE ? pluginWidth : hostedWidth}
									height={PLUGIN_MODE ? pluginHeight : hostedHeight}
									isFrame={isFrame}
									defaultPosition={settings.common.voxPosition === "defaultPosition"
										&& settings.common.voxButtonShape === "default"
									}
									ownTriggerButton={ownTriggerButton}
									isPublicHosted={settings.common.isPublicHosted}
									widthPercent={PLUGIN_MODE ? pluginWidthPercent
										: settings.common.isPublicHosted ? publicHostedWidthPercent
											: hostedWidthPercent}
									heightPercent={heightPercent}
									aspectRatio={PLUGIN_MODE ? (pluginHeight / pluginWidth) :
										(hostedHeight / hostedWidth)}
								>
									{/* Plugin header */}
									<Header />


									{/* The changing views */}
									<Pages
										active={pageOverride || page}
										onSwitch={(newPage, newProps) => this.switchPage(newPage, newProps)}
										showPopup={type => this.setState({ popup: type })}
                    micAllowed={micAllowed}
                    audioContext={audioContext}
                    handleAudioContext={(audioCon) => this.handleAudioContext(audioCon)}
										{...pageProps}
										togglePlugin={() => this.togglePlugin()}
										isFrame={isFrame && !ownTriggerButton}
									/>


									{/* Divider for footer */}
									<Divider />

									{/* Plugin footer */}
									<Footer activePage={page}
											onSwitch={(newPage, newProps) => this.switchPage(newPage, newProps)}/>

									{/* Dynamic popup */}
									<Popup pluginMode={PLUGIN_MODE} show={!!popup} type={popup} settings={settings} />
								</SubContainer>
							</VoxPosition>
							{/* The trigger button is required only in non fixed builds */}
							{ !isFrame && !inFixedMode ? (
								<VoxTrigger common={settings.common} isActive={!isActive}
											onToggle={() => this.togglePlugin()} title={isActive ? closePluginButton : openPluginButton} />
							) : null}
						</Settings.Provider>
					</PluginContainer>
				</ThemeProvider>
			</Draggable>
		) : null;
	}
}
